import { render, staticRenderFns } from "./CommodityList.vue?vue&type=template&id=8503dca6&scoped=true"
import script from "./CommodityList.vue?vue&type=script&lang=js"
export * from "./CommodityList.vue?vue&type=script&lang=js"
import style0 from "./CommodityList.vue?vue&type=style&index=0&id=8503dca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8503dca6",
  null
  
)

export default component.exports